import icon1 from '../../../Assets/Home/rate.png';
import icon2 from '../../../Assets/Home/solar-panel.png';
import icon3 from '../../../Assets/Home/experience.png';
import icon4 from '../../../Assets/Home/medal.png';
import { useNavigate } from 'react-router-dom';




const stats = [
  { id: 1, Icon: icon2,  value: "300 +", label: "Project Done" },
  { id: 2, Icon: icon3, value: "300 +", label: "Happy Clients" },
  { id: 3, Icon: icon4,  value: "50 +",   label: "Area Cover" },
  { id: 4, Icon: icon1, value: "300 +", label: "Rating Customer" },
];

const BoltIcon = () => (
  <svg className="w-4 h-4" fill="#4ade80" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 2L4.5 13.5H11L10 22L19.5 10.5H13L13 2Z" />
  </svg>
);

export default function CompanyOverview() {
  const navigate = useNavigate();
  return (
    <div
      className="w-full py-16 px-6 md:px-10 lg:px-12 xl:px-20"
      style={{ background: "#ffffff", }}
    >
      <div className=" flex flex-col lg:flex-row items-center gap-16">

        {/* ── Left column ── */}
        <div className=" max-w-sm">
          {/* Label */}
          <div className="flex  items-center gap-1.5 mb-3">
            <BoltIcon />
            <span
              className="text-sm font-rajdhani font-bold tracking-[0.18em] uppercase text-[#4ade80]"
            >
              OUR COMPANY
            </span>
          </div>

          {/* Heading */}
          <h2
            className="font-black font-rajdhani text-2xl md:text-4xl lg:text-[45px] text-[#1a2e0a] tracking-wide leading-relaxed mb-4"
          >
            Company Overview
          </h2>

          {/* Body */}
          <p className="text-gray-500 text-sm  md:text-base leading-relaxed mb-8 text-balance">
           Vishwaraja Enterprises believe in ethical business practices and sustainable growth, contributing positively to the community and the industries we serve. At Vishwaraja Enterprises, our goal is not just to meet expectations but to exceed them through consistency, quality, and commitment.
          </p>

          {/* CTA button */}
          <button
          onClick={()=>{
            navigate("/contact");
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            })
          }}
            className="font-bold bg-[#89EA5F] text-sm px-7 py-3.5 rounded-full transition-all duration-200 hover:opacity-90 hover:shadow-lg"
            style={{
              color: "#1a2e0a",
              boxShadow: "0 4px 14px rgba(74,222,128,0.35)",
            }}
          >
            Contact Now
          </button>
        </div>

        {/* ── Right grid — 2×2 stat cards ── */}
        <div className=" grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
          {stats.map(({ id, Icon, value, label }) => (
            <div
              key={id}
              className="flex items-center gap-4 rounded-2xl px-5 py-5 relative"
              style={{
                background: "#f0f5ee",
                border: "1.5px solid #e0ead8",
              }}
            >
              {/* Green icon box */}
              <div
                    className="flex items-center justify-center rounded-3xl p-6 bg-[#89EA5F]"
                  >
                    <img src={Icon} alt={label} className='size-16 object-cover ' />
                  </div>

              {/* Text */}
              <div>
                <p
                  className="font-black leading-none mb-1"
                  style={{ fontSize: "clamp(22px, 2.2vw, 28px)", color: "#1a2e0a" }}
                >
                  {value}
                </p>
                <p className="text-gray-500 text-sm">{label}</p>
              </div>

              {/* Small green dot accent (only on first card like design) */}
              {id === 1 && (
                <span
                  className="absolute bottom-4 right-4 w-2.5 h-2.5 rounded-full"
                  style={{ background: "#4ade80" }}
                />
              )}
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}